import React from 'react';
import Herosection from '../components/creative/Herosection';
import Services from '../components/creative/Services';
import Process from '../components/creative/Process';
import Portfolio from '../components/creative/Portfolio';
import Testimonial from '../components/creative/Testimonial';
import Team from '../components/creative/Team';
import Pricing from '../components/creative/Pricing';

const Creative = () => {
  return (
    <>
      <Herosection />
      <Services />
      <Process />
      <Portfolio />
      <Testimonial />
      <Team />
      <Pricing />
    </>
  )
}

export default Creative;